import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ApplyAlbumPhotosToEventPagesMutationVariables = Types.Exact<{
  payload: Types.ApplyAlbumPhotosToEventPagesInput;
}>;

export type ApplyAlbumPhotosToEventPagesMutation = { __typename?: 'Mutation'; applyAlbumPhotosToEventPages?: any | null };

export const ApplyAlbumPhotosToEventPagesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyAlbumPhotosToEventPages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplyAlbumPhotosToEventPagesInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyAlbumPhotosToEventPages' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ApplyAlbumPhotosToEventPagesMutationFn = Apollo.MutationFunction<ApplyAlbumPhotosToEventPagesMutation, ApplyAlbumPhotosToEventPagesMutationVariables>;

/**
 * __useApplyAlbumPhotosToEventPagesMutation__
 *
 * To run a mutation, you first call `useApplyAlbumPhotosToEventPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAlbumPhotosToEventPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAlbumPhotosToEventPagesMutation, { data, loading, error }] = useApplyAlbumPhotosToEventPagesMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useApplyAlbumPhotosToEventPagesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyAlbumPhotosToEventPagesMutation, ApplyAlbumPhotosToEventPagesMutationVariables>,
) {
  return ApolloReactHooks.useMutation<ApplyAlbumPhotosToEventPagesMutation, ApplyAlbumPhotosToEventPagesMutationVariables>(ApplyAlbumPhotosToEventPagesDocument, baseOptions);
}
export type ApplyAlbumPhotosToEventPagesMutationHookResult = ReturnType<typeof useApplyAlbumPhotosToEventPagesMutation>;
export type ApplyAlbumPhotosToEventPagesMutationResult = Apollo.MutationResult<ApplyAlbumPhotosToEventPagesMutation>;
export type ApplyAlbumPhotosToEventPagesMutationOptions = Apollo.BaseMutationOptions<ApplyAlbumPhotosToEventPagesMutation, ApplyAlbumPhotosToEventPagesMutationVariables>;
